import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ApplicationState } from '../types';
import { FEATURE_NAME_CORE } from '../reducer/core.reducer';

export const getCoreState =
  createFeatureSelector<ApplicationState>(FEATURE_NAME_CORE);

export const getBanner = (state: ApplicationState) => state?.banner;

export const selectBannerState = createSelector(getCoreState, getBanner);
